<template>
  <b-card no-body class="border mb-2 h-100">
    <b-card-body>
      <h5 class="mb-0">Latency distribution</h5>
      <small class="text-muted d-block mb-1">
        Where requests actually land — percentiles are interpolated from these bins
      </small>

      <div v-if="!hasData" class="text-center text-muted py-4">
        No traffic in this window.
      </div>

      <vue-apex-charts
        v-else
        type="bar"
        height="240"
        width="100%"
        :options="chartOptions"
        :series="series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'UsageLatencyChart',
  components: {
    BCard,
    BCardBody,
    VueApexCharts,
  },
  props: {
    latency: {
      type: Object,
      default: () => ({ labels: [], counts: [] }),
    },
  },
  computed: {
    counts() {
      return this.latency?.counts || []
    },
    hasData() {
      return this.counts.some(count => count > 0)
    },
    series() {
      return [{ name: 'Requests', data: this.counts }]
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false }, type: 'bar' },
        colors: ['#7367f0'],
        dataLabels: { enabled: false },
        plotOptions: { bar: { borderRadius: 3, columnWidth: '60%' } },
        grid: { borderColor: '#ebe9f1', strokeDashArray: 4 },
        xaxis: {
          categories: this.latency?.labels || [],
          labels: { rotate: -45, style: { fontSize: '10px' } },
        },
        yaxis: { labels: { formatter: value => Math.round(value) } },
      }
    },
  },
}
</script>
